
import { Injectable } from '@angular/core';
import { AuthService, GlobalMessageService, WindowRef, OccEndpointsService } from '@spartacus/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export  class PersonalDetailsService {
    
    constructor(
        private httpClient: HttpClient,
        private occService: OccEndpointsService
      ) {
      }  
      getPersonalDetails(uid: any) : Observable<any> {
        const fetchUrl = this.occService.buildUrl(
          `/orgUsers/${uid}?fields=DEFAULT`
        );
        return this.httpClient.get<any>(fetchUrl);
      }
}

